// extracted by mini-css-extract-plugin
export default {"htmlSnippet":"CustomNotificationBanner_htmlSnippet--xtE"};